import './reviews.component.scss'

import 'swiper/css'
import 'swiper/css/navigation'

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

new Swiper('.reviews-slider', {
	modules: [ Navigation ],
	spaceBetween: 25,
	autoHeight: true,
	navigation: {
		nextEl: '.reviews-slider__next',
		prevEl: '.reviews-slider__prev',
	},
	slidesPerView: 1,
	breakpoints: {
		991: {
      slidesPerView: 2,
    },
	}
})
